import track from 'analytics/track';

/**
 * Calls the Reveal FAQ Answer tracking event, this is called on the PDPs.
 * @param {string} product The product category of that PDP's respective product
 * @param {string} question The question for that FAQ
*/
export const faqQuestion = (product, question) => {
  const faqQuestionParams = {
    params: {
      ga: {
        eventAction: `Reveal FAQ Answer`,
        eventCategory: product,
        eventLabel: question,
      },
      heap: {
        eventName: `Reveal FAQ Answer`,
        properties: {
          question,
        },
      },
    },
  };
  track(faqQuestionParams);
};
